window.axios = require('axios');
import router from './router';
import store from './store';
import axios from 'axios';

axios.defaults.baseURL = process.env.VUE_APP_API_URL;
axios.defaults.headers.common['AccessingFrom'] = "web_driver";
if (localStorage.getItem('token')) {
    axios.defaults.headers.common['Authorization'] = "Bearer " +localStorage.getItem('token');
}

axios.interceptors.request.use(function (config) {
    store.commit("changeLoading",store.state.loading+1);
    router.app.$Progress.start();
    return config;
}, function (err) {
    store.commit("changeLoading",store.state.loading-1);
    if(store.state.loading === 0){
        router.app.$Progress.fail();
    }
    return Promise.reject(err);
});

axios.interceptors.response.use(response => {
    store.commit("changeLoading",store.state.loading-1);
    if(store.state.loading === 0){
        router.app.$Progress.finish();
    }
    return response;
}, function (err) {
    store.commit("changeLoading",store.state.loading-1);
    if(store.state.loading === 0){
        router.app.$Progress.fail();
    }
    return Promise.reject(err);
});

export default axios;

